import CloseIcon from '@mui/icons-material/Close';
// import StarIcon from '@mui/icons-material/Star';
import {
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // List,
  // ListItem,
  // ListItemText,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/system';
import React from 'react';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
  // isPriceView1099s?: boolean;
  // setIsPriceView1099s?: (value: boolean) => void;
}
export interface ExitPopupWagesTaxProps {
  isPriceView1099s: boolean;
  setIsPriceView1099s: React.Dispatch<React.SetStateAction<boolean>>;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ExitPopupWage = (props: ExitPopupWagesTaxProps): React.JSX.Element => {
  const [open, setOpen] = React.useState(false);

  // useBasicExitIntent(() => {
  //     setOpen(true);
  //   });

  React.useEffect(() => {
    setOpen(props.isPriceView1099s);
  }, [props.isPriceView1099s]);

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
    props.setIsPriceView1099s(false);
  };

  // const [isCopied, setCopied] = useClipboard('TZOEMP10', {
  //   successDuration: 6000,
  // });
  return (
    <BootstrapDialog
      onClose={(_event, _reason) => {
        // Optionally handle other close reasons here
      }}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="info-exit-theme"
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      />
      <DialogContent>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 3 }}
            alignItems="center"
            justifyContent="space-around"
            sx={{ px: { xs: 0, sm: 2 }, mb: 1 }}
          >
            <Box
              component="img"
              src="/assets/images/1099s-pricing-img.png"
              loading="lazy"
              alt="How TaxZerone’s Pricing Works?"
              width={150}
              height={100}
            />

            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 18, sm: 24, md: 28 },
                  color: '#333',
                }}
              >
                How TaxZerone’s{' '}
                <span style={{ color: '#4269e2' }}>Pricing</span> Works?
              </Typography>
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  color: '#333',
                }}
              >
                Save more as you file more—our pricing drops as your volume
                increases.
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction={{ xs: 'column', sm: 'column' }}
            spacing={{ xs: 1, sm: 2, md: 0 }}
            sx={{ borderTop: '1px solid #ccc' }}
          >
            <Typography
              variant="body1"
              sx={{ mt: '16px !important', mb: '10px !important' }}
            >
              <span style={{ fontWeight: 600 }}> For Example:</span> Let’s say
              you need to file{' '}
              <span style={{ fontWeight: 600 }}>120 W-2 forms.</span>
            </Typography>
            <Box component="div" sx={{ mb: 0 }}>
              <TableContainer
                sx={{ border: '1px solid #828282', borderRadius: 2 }}
              >
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableHead />
                  <TableBody sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableRow sx={{}}>
                      <TableCell>
                        <span style={{ fontWeight: 600 }}>First 25 forms</span>{' '}
                        of W-2{' '}
                      </TableCell>
                      <TableCell>25 x $2.49 </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>$62.25 </TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell>
                        <span style={{ fontWeight: 600 }}> Next 25 forms</span>{' '}
                        (forms 26–50) of W-2
                      </TableCell>
                      <TableCell>25 x $1.99 </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>$49.75 </TableCell>
                    </TableRow>
                    <TableRow sx={{}}>
                      <TableCell>
                        <span style={{ fontWeight: 600 }}> Next 50 forms</span>{' '}
                        (forms 51–100) of W-2
                      </TableCell>
                      <TableCell>50 x $1.59</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>$79.50</TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell>
                        <span style={{ fontWeight: 600 }}> Next 20 forms</span>{' '}
                        (forms 101–120) of W-2
                      </TableCell>
                      <TableCell>20 x $ 1.29</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>$25.80</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Typography variant="body1" sx={{ mt: 2, textAlign: 'right' }}>
                {' '}
                Total Cost ={' '}
                <span
                  style={{
                    fontWeight: 800,
                    fontSize: '20px !important',
                  }}
                >
                  $217.30
                </span>{' '}
                for 120 forms{' '}
              </Typography>
            </Box>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions
      // sx={{
      //   justifyContent: 'center',
      //   pb: '24px !important',
      //   textAlign: 'center',
      //   backgroundColor: '#f9f9f9',
      //   borderTop: '1px solid #ccc',
      // }}
      >
        {/* <Box sx={{ px: { xs: 1, sm: 3 }, mt: 1 }}>
          <Typography
            variant="body1"
            sx={{ fontSzie: 16, fontWeight: 500, mb: 1 }}
          >
          
            Don&apos;t Miss Out on Easy Tax Filing With TaxZerone
          </Typography>
          <Button
            variant="contained"
            size="large"
            // className="btn-primary"
            sx={{
              textTransform: 'none',
              boxShadow: 'none',
              borderRadius: 4,
              display: 'inline-block',
              fontSize: { xs: 18, sm: 20, md: 22, lg: 24 },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941`}
          >
            E-File Now!
          </Button>
        </Box> */}
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ExitPopupWage;
